"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DirectPaths = exports.StoragePaths = exports.MetrcFacilityConstantDoc = exports.MetrcFacilitySubCollections = exports.MetrcLocationSubCollections = exports.Collections = void 0;
exports.Collections = {
    strains: 'strains',
    packageItems: 'packageItems',
    tests: 'tests',
    users: 'users',
    notifications: 'notifications',
    infoArticles: 'infoArticles',
    infoCategories: 'infoCategories',
    inventoryDetails: 'inventoryDetails',
    inventoryCategories: 'inventoryCategories',
    equipment: 'equipment',
    consumables: 'consumables',
    externalContacts: 'externalContacts',
    metrcFacilities: 'metrcFacilities',
    scheduleTasks: 'scheduleTasks',
};
exports.MetrcLocationSubCollections = {
    environment: 'environment',
    history: 'history',
    systems: 'systems'
};
var MetrcFacilitySubCollections;
(function (MetrcFacilitySubCollections) {
    MetrcFacilitySubCollections["metrcConstants"] = "metrcConstants";
    MetrcFacilitySubCollections["metrcHarvests"] = "metrcHarvests";
    MetrcFacilitySubCollections["metrcPlants"] = "metrcPlants";
    MetrcFacilitySubCollections["metrcPlantBatches"] = "metrcPlantBatches";
    MetrcFacilitySubCollections["metrcPlantBatchTypes"] = "metrcPlantBatchTypes";
    MetrcFacilitySubCollections["metrcLocations"] = "metrcLocations";
    MetrcFacilitySubCollections["metrcPackages"] = "metrcPackages";
    MetrcFacilitySubCollections["metrcStrains"] = "metrcStrains";
    MetrcFacilitySubCollections["metrcItems"] = "metrcItems";
    MetrcFacilitySubCollections["metrcTransfers"] = "metrcTransfers";
})(MetrcFacilitySubCollections = exports.MetrcFacilitySubCollections || (exports.MetrcFacilitySubCollections = {}));
exports.MetrcFacilityConstantDoc = {
    metrcLocationTypes: 'metrcLocationTypes',
    metrcPlantWasteReasons: 'metrcPlantWasteReasons',
    metrcPackageAdjustReasons: 'metrcPackageAdjustReasons',
};
exports.StoragePaths = {
    images: 'images/',
};
exports.DirectPaths = {
    orgSettings: 'org/settings',
    orgMetrcSync: 'org/metrcSync',
    metrcUnitsOfMeasure: 'metrc/unitsOfMeasure',
    metrcPlantBatchTypes: 'metrc/plantBatchTypes',
    metrcPackageTypes: 'metrc/packageTypes',
    metrcHarvestWasteTypes: 'metrc/harvestWasteTypes',
    metrcAdditiveTypes: 'metrc/additiveTypes',
    metrcPlantWasteMethods: 'metrc/plantWasteMethods',
    metrcItemCategories: 'metrc/metrcItemCategories',
};
//# sourceMappingURL=firebaseConstants.js.map